import React from 'react';
import { Users, Target, Briefcase, TrendingUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const SolutionsModal: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="text-slate-300 space-y-6">
      {/* Introduction */}
      <div className="text-center mb-8">
        <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-3xl flex items-center justify-center shadow-2xl">
          <Users className="w-10 h-10 text-white" />
        </div>
        <p className="text-lg leading-relaxed">
          {t('footer.modals.solutions.description')}
        </p>
      </div>

      {/* Solutions for candidates */}
      <div className="space-y-6">
        <div className="bg-slate-700/30 rounded-2xl p-6">
          <h3 className="text-xl font-semibold text-white mb-4 flex items-center">
            <Target className="w-6 h-6 mr-3 text-emerald-400" />
            {t('footer.modals.solutions.cv_analysis.title')}
          </h3>
          <div className="space-y-3">
            {t('footer.modals.solutions.cv_analysis.features', { returnObjects: true }).map((feature: string, index: number) => (
              <div key={index} className="flex items-start">
                <div className="w-2 h-2 bg-emerald-400 rounded-full mr-3 mt-2"></div>
                <p>{feature}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-slate-700/30 rounded-2xl p-6">
          <h3 className="text-xl font-semibold text-white mb-4 flex items-center">
            <Briefcase className="w-6 h-6 mr-3 text-blue-400" />
            {t('footer.modals.solutions.optimization.title')}
          </h3>
          <div className="space-y-3">
            {t('footer.modals.solutions.optimization.features', { returnObjects: true }).map((feature: string, index: number) => (
              <div key={index} className="flex items-start">
                <div className="w-2 h-2 bg-blue-400 rounded-full mr-3 mt-2"></div>
                <p>{feature}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-slate-700/30 rounded-2xl p-6">
          <h3 className="text-xl font-semibold text-white mb-4 flex items-center">
            <TrendingUp className="w-6 h-6 mr-3 text-purple-400" />
            {t('footer.modals.solutions.career_support.title')}
          </h3>
          <div className="space-y-3">
            {t('footer.modals.solutions.career_support.features', { returnObjects: true }).map((feature: string, index: number) => (
              <div key={index} className="flex items-start">
                <div className="w-2 h-2 bg-purple-400 rounded-full mr-3 mt-2"></div>
                <p>{feature}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Call to action */}
      <div className="bg-gradient-to-br from-emerald-500/10 to-teal-600/10 border border-emerald-500/20 rounded-2xl p-6 text-center">
        <h3 className="text-xl font-bold text-white mb-3">
          {t('footer.modals.solutions.cta.title')}
        </h3>
        <button 
          onClick={() => {
            // Close modal first
            const closeButton = document.querySelector('[data-modal-close]') as HTMLButtonElement;
            if (closeButton) closeButton.click();
            
            // Then redirect to registration section
            setTimeout(() => {
              const uploadSection = document.querySelector('#upload-section');
              if (uploadSection) {
                uploadSection.scrollIntoView({ behavior: 'smooth' });
              }
            }, 300);
          }}
          className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-emerald-600 to-teal-600 text-white font-semibold rounded-xl hover:from-emerald-700 hover:to-teal-700 transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl"
        >
          {t('footer.modals.solutions.cta.button')}
        </button>
      </div>
    </div>
  );
};

export default SolutionsModal;
